
export const robinMediaArray = [
  {
    _id: 'robinMediaId1',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-1-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `I can teach you how to`,
      `My best blue steel`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId2',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-2-p.png`,
    description: ``,
    captions: [
      `I'm known for`,
      `How history will remember me`,
      `My life behind the scenes`
    ],
    subcaptions: [
      `When your hockey team puts up a stinker`,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId3',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-3-p.png`,
    description: ``,
    captions: [
      `Plandid or candid?`,
      `My good side`,
      `Leave a one-word review for this`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId4',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-4-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `Life outtake`,
      `The advertisement for my life would look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId5',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-5-p.png`,
    description: ``,
    captions: [
      `Don't judge me`,
      `Caught in the act`,
      `Don't show this to my mom`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId6',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-6-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `Felt cute might delete later`,
      `I feel famous when`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId7',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-7-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId8',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-8-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `How my friends see me`,
      `Dating me will look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId9',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-9-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `Felt cute might delete later`,
      `I feel famous when`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId10',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-10-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-10-p.png`,
    description: ``,
    captions: [
      `How my friends see me`,
      `Leave a one-word review for this`,
      `Me in the wild`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId11',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-11-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-11-p.png`,
    description: ``,
    captions: [
      `My best blue steel`,
      `My good side`,
      `Lowkey flex`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId12',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-12-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-12-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `Felt cute might delete later`,
      `My life behind the scenes`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId13',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-13-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-13-p.png`,
    description: ``,
    captions: [
      `My good side`,
      `Plandid or candid?`,
      `My life behind the scenes`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId14',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-14-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-14-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `Plandid or candid?`,
      `Me in my blogging days`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId15',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-15-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-15-p.png`,
    description: ``,
    captions: [
      `Don't judge me`,
      `My uniform`,
      `Caption this photo`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'robinMediaId16',
    userId: 'robinUserId',
    email: 'robin@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-16-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-robin-s-16-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `As seen on my Mom's fridge`,
      `Plandid or candid?`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]